<template>
  <InputPopover
    ref="popover"
    v-bind="{ modelValue, icon, borderless, outlined, dense, error, errorMessage, label, placeholder, useInput, clearable, autofocus, separator, multiple, disable, hideSelected, display, valueDebounce, showSelection, hideOnFirstClick, inputClass, ...$attrs }"
    :search="search"
    :loading="loading"
    :results="results"
    :placeholder="placeholder"
    :debounce="900"
    friendly-name="client"
    option-label="display_name"
    separator
    @blur="onBlur"
    @clear="onClear"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  >
    <template v-if="canCreate" #create>
      <clickable-item
        v-close-popup
        label="Create New Client"
        @click="$refs.clientAddDialog.open()"
      />
    </template>

    <template v-if="$slots.advanced" #advanced>
      <slot name="advanced" />
    </template>

    <template #option="scope">
      <client-item
        v-bind="scope.itemProps"
        :client="scope.opt"
        dense
      >
        <template v-if="showSelection" #default>
          <component
            :is="multiple ? 'q-checkbox' : 'q-radio'"
            :model-value="scope.selected"
            :val="true"
            dense
            class="no-pointer-events"
          />
        </template>
      </client-item>
    </template>

    <template
      #selected-chip="scope"
    >
      <client-chip
        dense
        removable
        without-btns
        :client="scope.opt"
        @click.stop
        @remove="removeModelAtIndex(scope.index)"
      />
    </template>

    <template #selected-item="scope">
      <client-item
        :client="scope.item"
        :disable="disable"
        clickable
        dense
        without-address
        prevent-side-click
        @click="viewingClientID = scope.item.id"
      >
        <cancel-button
          v-if="!disable"
          @click="removeModelAtIndex(scope.index)"
        />
      </client-item>
    </template>
  </InputPopover>

  <ClientViewDialog
    :id="viewingClientID"
    :with-quick-links="false"
    @close="viewingClientID = null"
    @updated="findAndReplaceModel"
  />

  <ClientAddDialog
    ref="clientAddDialog"
    @created="onResultClick"
  />
</template>

<script>
import InputPopover from 'components/partials/search/inputPopover/InputPopover'
import inputPopoverMixin from 'components/partials/search/inputPopover/inputPopoverMixin'

import searchMixin from './mixins/searchMixin'
import ClientViewDialog from './view/Dialog'
import ClientAddDialog from './../Add'

export default {
  components: {
    InputPopover, ClientAddDialog, ClientViewDialog
  },
  mixins: [searchMixin, inputPopoverMixin],
  props: {
    canCreate: {
      type: Boolean,
      default: false
    },
    withPhones: {
      type: String,
      default: 'NONE'
    },
    withAddresses: {
      type: String,
      default: 'NONE'
    },
    withEmails: {
      type: String,
      default: 'NONE'
    },
    parentOfClient: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      viewingClientID: null
    }
  },
  methods: {
    search (val, update, abort) {
      this.doSearch({
        value: val,
        with_phones: this.withPhones,
        with_addresses: this.withAddresses,
        with_emails: this.withEmails,
        parent_of_client: this.parentOfClient
      }, () => {
        update()
      }, () => {
        abort()
      })
    }
  }
}
</script>
